"use strict";
(self["webpackChunkretail_samen_rekening_openen_asn"] = self["webpackChunkretail_samen_rekening_openen_asn"] || []).push([[735],{

/***/ 6735
(module) {

module.exports = /*#__PURE__*/JSON.parse('{"samen-rekening-openen.title":{"default":"Samen openen"},"samen-rekening-openen.mobile.title":{"default":"Rekening openen"},"samen-rekening-openen.logout":{"default":"/onlinebankieren/secure/logout/directLogout.html","reb":"/internetbankieren/secure/logout/directLogout.html","sns":"/mijnsns/secure/logout/directLogout.html"}}');

/***/ }

}]);